import { createSlice } from '@reduxjs/toolkit';

const webCastLoginSlice = createSlice({
  name: 'webcastLogin',
  initialState: {
    attendanceId: null,
    webcastTitle: '',
    streamType: '',
    message: '',
    success: false
  },
  reducers: {
    setWebcastLoginData: (state, action) => {
      state.attendanceId = action.payload.data?.attendanceId;
      state.webcastTitle = action.payload.data?.webcastTitle;
      state.streamType = action.payload.data?.streamType;
      state.message = action.payload.message;
      state.success = action.payload.success;
    }
  }
});

export const { setWebcastLoginData } = webCastLoginSlice.actions;
export default webCastLoginSlice.reducer;
